import { Box, Link, Typography } from '@mui/material';
import { InfoCard } from '../../components/InfoCard';
import { MainContainer } from '../../components/MainContainerComp';
import { linkStyle, textStyle } from './styled';

export const BenefitsLinks = () => (
  <MainContainer>
    <Box sx={{ mb: 3, mt: 2 }}>
      <Typography sx={textStyle}>
        For information on your benefit coverage please contact the Waterfront Employers Benefit Office at (604) 689-7184.
      </Typography>
      <Typography sx={textStyle}>
        For Longshore members, the pension and benefits Trusts have created a website at <Typography component={"span"}> <Link href=" http://www.longshoreplans.ca" sx={linkStyle} target="_blank">Longshore Plans</Link></Typography>
      </Typography>
    </Box>
    <Box sx={{ mb: 3, mt: 2 }}>
      <InfoCard header='Waterfront Employer of BC Links:'>
        <Box>
          <img
            alt="webc"
            src={`/assets/images/webc_icon.png`}
            style={{ display: 'inline-block', marginRight: '10px', position: 'relative', top: '10px' }}
            data-automation="webc-img"
          />
          <Link data-automation="longshoreman-hyperlink" href="https://www.longshoreplans.ca/Trusted/General" sx={linkStyle} target="_blank">
            WEBC Longshoremen Benefits
          </Link>
        </Box>
        <Box>
          <img
            alt="webc"
            src={`/assets/images/webc_icon.png`}
            style={{ display: 'inline-block', marginRight: '10px', position: 'relative', top: '10px' }}
            data-automation="webc-img"
          />
          <Link data-automation="foreman-hyperlink" href="https://www.foremenplans.ca/Account/Login" sx={linkStyle} target="_blank">
            WEBC Foremen Benefits
          </Link>
        </Box>
      </InfoCard>
    </Box>
    <Box sx={{ mb: 3 }}>
      <InfoCard header='ADP Links:'>
        <Box>
          <img
            alt="adp"
            src={`/assets/images/adp_icon.png`}
            style={{ display: 'inline-block', marginRight: '10px', position: 'relative', top: '10px' }}
            data-automation="adp-img"
          />
          <Link data-automation="employee-logins-hyperlink" href="https://www.adp.ca/en/logins.aspx" sx={linkStyle} target="_blank">
            Employee Logins
          </Link>
        </Box>
        <Box>
          <img
            alt="adp"
            src={`/assets/images/adp_icon.png`}
            style={{ display: 'inline-block', marginRight: '10px', position: 'relative', top: '10px' }}
            data-automation="adp-img"
          />
          <Link data-automation="employee-logins-hyperlink" href="/assets/documents/SSS_BCMEA_Nov_2016.pdf" sx={linkStyle} target="_blank">
            Statement Self-Service Instructions
          </Link>
        </Box>
      </InfoCard>
    </Box>
  </MainContainer>
);
